import type {
  ContinuousScrollerComparisonType,
  ContinuousScrollerFilter,
  DataGridColumnSettings,
} from '@myosh/odin-components';
import type { FieldFilters } from '../../@types/common';

export interface MobileCardsFilterRef {
  resetToInitial: (columns?: DataGridColumnSettings[], initialFieldFilters?: ContinuousScrollerFilter[]) => void;
}

const SUPPORTED_FILTERS = ['TextSearch', 'MultiSelect', 'Integer', 'Decimal', 'DateRange'];

export const isFilterSupported = (filterType?: string) => {
  return filterType && SUPPORTED_FILTERS.includes(filterType);
};

/**
 * Helper function to get ContinuousScrollerFilters from column settings and additional filters.
 * @param columns to read initial filters from
 * @param additionalFilters to be applied to final filters
 * @returns combined filters from columns and additionalFilters
 */
export const getContinuousScrollerFilters = (
  columns: DataGridColumnSettings[],
  additionalFilters: ContinuousScrollerFilter[] = []
): ContinuousScrollerFilter[] => {
  if (columns) {
    const columnInitialFilters = columns
      .filter((column) => isFilterSupported(column.searchType) && column.searchValue)
      .map((column) => {
        return {
          scrollerId: column.id as string | number,
          field: column.field,
          customDataProperties: { ...column.customDataProperties, originalComparison: column.searchComparison },
          comparison: column.searchComparison ?? 0,
          value: column.searchValue ?? '',
        } as ContinuousScrollerFilter;
      });

    const mainFilters = additionalFilters.map((filter) => ({
      ...filter,
      customDataProperties: { ...filter.customDataProperties, originalComparison: filter.comparison },
    }));

    return [...columnInitialFilters, ...mainFilters];
  }
  return [];
};

export const convertToContinuousScrollerFilters = (fieldFilters: FieldFilters): ContinuousScrollerFilter[] => {
  const result: ContinuousScrollerFilter[] = [];
  Object.keys(fieldFilters).forEach((key) => {
    const filter = fieldFilters[key];
    result.push({
      scrollerId: key,
      field: key,
      value: filter.value,
      comparison: (filter.customDataProperties?.originalComparison as ContinuousScrollerComparisonType) ?? 0,
      customDataProperties: filter.customDataProperties,
    });
  });
  return result;
};
